export default "__VITE_ASSET__mZcUJB7l__"